var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('v-main',[_c('error',{staticClass:"pb-5"})],1),_c('v-footer',{attrs:{"padless":"","absolute":"","app":""}},[_c('idp-footer',{staticStyle:{"min-width":"100%"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }